import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import './SignupPage.css';

function ActivationPage() {
  const [status, setStatus] = useState('processing'); // processing, success, error
  const [message, setMessage] = useState('');
  const location = useLocation();

  useEffect(() => {
    const activateAccount = async () => {
      const params = new URLSearchParams(location.search);
      const token = params.get('token');

      if (!token) {
        setStatus('error');
        setMessage('Invalid activation link. No token provided.');
        return;
      }

      try {
        const response = await fetch(`/api/auth/activate?token=${token}`);
        const data = await response.json();

        if (response.ok && data.success) {
          setStatus('success');
          setMessage(data.message || 'Account activated successfully!');
        } else {
          setStatus('error');
          setMessage(data.error || 'Activation failed. Please try again.');
        }
      } catch (error) {
        setStatus('error');
        setMessage('Network error. Please check your connection and try again.');
      }
    };

    activateAccount();
  }, [location]);

  return (
    <div className="signup-page">
      <div className="signup-container">
        <div className="success-card">
          {status === 'processing' && (
            <>
              <div className="loading-spinner">
                <div className="spinner"></div>
              </div>
              <h1>Activating Your Account...</h1>
              <p className="success-message">Please wait while we verify your activation link.</p>
            </>
          )}

          {status === 'success' && (
            <>
              <div className="success-icon">
                <svg width="64" height="64" viewBox="0 0 64 64" fill="none">
                  <circle cx="32" cy="32" r="32" fill="#10B981"/>
                  <path d="M20 32 L28 40 L44 24" stroke="white" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <h1>Account Activated!</h1>
              <p className="success-message">{message}</p>
              <div className="success-info">
                <p>🎉 Your account is now active and ready to use</p>
                <p>🚀 You can now sign in and start exploring CerebralMachines</p>
              </div>
              <a href="/login" className="btn-primary btn-large">
                Go to Login
              </a>
            </>
          )}

          {status === 'error' && (
            <>
              <div className="error-icon">
                <svg width="64" height="64" viewBox="0 0 64 64" fill="none">
                  <circle cx="32" cy="32" r="32" fill="#EF4444"/>
                  <path d="M20 20 L44 44 M44 20 L20 44" stroke="white" strokeWidth="4" strokeLinecap="round"/>
                </svg>
              </div>
              <h1>Activation Failed</h1>
              <p className="success-message" style={{color: '#EF4444'}}>{message}</p>
              <div className="success-info" style={{background: 'rgba(239, 68, 68, 0.1)', borderColor: 'rgba(239, 68, 68, 0.2)'}}>
                <p>⚠️ The activation link may have expired or is invalid</p>
                <p>📧 Please request a new activation link or contact support</p>
              </div>
              <div style={{display: 'flex', gap: '12px', justifyContent: 'center'}}>
                <a href="/signup" className="btn-primary btn-large">
                  Sign Up Again
                </a>
                <a href="/" className="btn-outline btn-large">
                  Go Home
                </a>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default ActivationPage;



